export interface HospitalOption {
  value: string;
  description: string;
  [key: string]: unknown;
}

export function normalizeAuthorizedHospitals(value: unknown): HospitalOption[] {
  if (!Array.isArray(value)) return [];

  const seenCodes = new Set<string>();
  return value.flatMap((item) => {
    if (!item || typeof item !== "object") return [];

    const hospital = item as Record<string, unknown>;
    if (typeof hospital.value !== "string" || !hospital.value.trim()) return [];

    const code = hospital.value.trim();
    if (seenCodes.has(code)) return [];
    seenCodes.add(code);
    const description =
      typeof hospital.description === "string" && hospital.description.trim()
        ? hospital.description.trim()
        : code;

    return [{ ...hospital, value: code, description } as HospitalOption];
  });
}

export function resolveAuthorizedHospitalCode(
  options: HospitalOption[],
  storedCode: unknown
): string {
  const code = typeof storedCode === "string" ? storedCode : "";
  return options.some((item) => item.value === code) ? code : options[0]?.value || "";
}

export function canUseHospitalScope(
  multiRegion: unknown,
  options: HospitalOption[]
): boolean {
  return multiRegion === true && options.length > 0;
}

export function shouldAttachHospitalScope(
  url: unknown,
  options: HospitalOption[],
  selectedCode: unknown
): boolean {
  const code = typeof selectedCode === "string" ? selectedCode : "";
  if (!code || !options.some((item) => item.value === code)) return false;

  const path = typeof url === "string" ? url.split("?")[0] : "";
  if (path === "/login" || path === "/logout" || path === "/hospital/list") return false;
  return !/^\/users\/[^/]+\/permissions$/.test(path);
}
